import React, { useEffect, useState } from 'react'
import Modal from '@/components/Modal'
import {useTranslation} from "@/langs/useTranslation";
import { Box, CircularProgress, Paper, Typography } from '@material-ui/core';
import { deleteFileApi, getFileConfigRefList, getFileSharedInfo } from '@/apis/apiCollection';
import * as dayjs from 'dayjs';

const DeleteFileModal = React.memo(({ fileInfo, onClose, onOk, open, tip="" }) => {
  const {t} = useTranslation();
  const [refConfig, setRefConfig] = useState([])
  const [shared, setShared] = useState(false)
  const [loading, setLoading] = useState(false)

  const checkFile = async () => {
      setLoading(true)
      try {
        const { configs } = await getFileConfigRefList({id: fileInfo.id})
        const { shared } = await getFileSharedInfo({id: fileInfo.id})
        setRefConfig(configs)
        setShared(shared)
      } catch(e) {

      } finally {
        setLoading(false)
      }
  }

  useEffect(() => {
    if (open) {
      checkFile()
    }
  }, [open])

  if (!open) return null
  return (
    <Modal
      title={t({defaultMessage: "移除文件"})}
      open={open}
      onClose={onClose}
      onConfirm={async () => {
        await deleteFileApi({id: fileInfo.id})
        onOk()
      }}
      showConfirm={!loading && refConfig.length===0}
    >
      { loading? 
        (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <CircularProgress style={{marginLeft: "auto", marginRight: "auto"}} />
          </Box>
        ):
        (
          <>
            { (refConfig.length == 0 && !shared)? 
              <Typography variant="body1">
                {tip}
              </Typography>:
              <Typography variant="body1">
                {refConfig.length > 0? 
                  t({defaultMessage: "此项目已被【{name}】配置文件所使用，无法删除，若要删除项目请至配置文件中将项目移除"}, {name: refConfig.map(v => v.name).join(',')})
                  :t({defaultMessage: "此文件已被共享，确认要移除此文件吗？"})
                }
              </Typography>
            }
            <div style={{padding: 16, background: "#F8F9FC", marginTop: 16}}>
              <Typography variant="body1" style={{wordBreak: 'break-all'}}>
                {t({defaultMessage: "程序名称："})}{fileInfo.name}
              </Typography>
              <Typography variant="body1" style={{wordBreak: 'break-all'}}>
                {t({defaultMessage: "上传时间："})}{dayjs(fileInfo.uploaded_at).format('YYYY-MM-DD hh:mm:ss')}
              </Typography>
            </div>
          </>
        )
      }
    </Modal>
  )

})

export default DeleteFileModal